export default "__VITE_PUBLIC_ASSET__d1bf559c__"